export function createGridOverlay({ baseObjects = [], density = 1, gridExpand = 0 }) {
    if (baseObjects.length == 0) {
        console.warn(`Add at least one object with 'query'(string) or 'el'(HTMLElement) key`)
    }
    if (density < 1) {
        console.warn('Density must be positive number')
    }

    const scroll = {
        y: document.documentElement.scrollTop,
        x: document.documentElement.scrollLeft
    }

    const decorateObject = ({ el = null, query = null, expand = 0, walkable = false } = {}) => {
        el = el ? el : document.querySelector(query)
        if (!el) {
            console.warn(`Couldn't find element by query: '${query}'`)
            return
        }
        const rect = el.getBoundingClientRect()
        return {
            el,
            expand,
            walkable,
            pos: {
                x: rect.x + scroll.x - expand,
                y: rect.y + scroll.y - expand,
                width: Math.max(rect.width,1) + 2*expand,
                height: Math.max(rect.height,1) + 2*expand,
            },
        }
    }

    const objects = baseObjects.map(object => decorateObject(object))
    const gridMeta = getGridMeta(objects)

    objects.forEach(object => {
        object.normPos = {
            x: Math.ceil(object.pos.x - gridMeta.x),
            y: Math.ceil(object.pos.y - gridMeta.y),
            width: Math.ceil(object.pos.x + object.pos.width) - Math.floor(object.pos.x),
            height: Math.ceil(object.pos.y + object.pos.height) - Math.floor(object.pos.y),
        }
    })

    const normMeta = getNormMeta(objects)

    //make grid larger with walkable edge cells
    if (gridExpand) {
        expandGridMetaAndObjects({
            gridExpand,
            gridMeta,
            normMeta,
            objects
        })
    }



    //create empty grid
    const grid = []
    for (let y = 0; y <= normMeta.height; y++) {
        grid[y] = []
        for (let x = 0; x <= normMeta.width; x++) {
            grid[y][x] = 0
        }
    }


    //create obsticles in grid
    objects
        .filter(object => !object.walkable)
        .forEach((object) => {
            for (let y = object.normPos.y; y < object.normPos.y + object.normPos.height; y++) {
                for (let x = object.normPos.x; x < object.normPos.x + object.normPos.width; x++) {
                    grid[y][x] = 1
                }
            }
        })

    return {
        grid,
        objects,
        gridMeta,
        normMeta
    }
}

function expandGridMetaAndObjects({gridExpand, gridMeta, normMeta, objects}={}) {
    gridMeta.x -= gridExpand
    gridMeta.y -= gridExpand
    gridMeta.x2 += gridExpand
    gridMeta.y2 += gridExpand
    gridMeta.width += 2*gridExpand
    gridMeta.height += 2*gridExpand

    normMeta.x -= gridExpand
    normMeta.y -= gridExpand
    normMeta.x2 += gridExpand
    normMeta.y2 += gridExpand
    normMeta.width += 2*gridExpand
    normMeta.height += 2*gridExpand

    objects.forEach(object => {
        object.normPos.x += gridExpand
        object.normPos.y += gridExpand
    })
}
function getNormMeta(objects) {
    return objects.reduce((acc, object) => {
        if (object.normPos.x < acc.x) acc.x = object.normPos.x
        if (object.normPos.y < acc.y) acc.y = object.normPos.y
        if (object.normPos.x + object.normPos.width > acc.x2) acc.x2 = object.normPos.x + object.normPos.width
        if (object.normPos.y + object.normPos.height > acc.y2) acc.y2 = object.normPos.y + object.normPos.height
        acc.width = acc.x2 - acc.x
        acc.height = acc.y2 - acc.y
        return acc
    }, {
        x: Number.MAX_VALUE,
        y: Number.MAX_VALUE,
        x2: Number.MIN_VALUE,
        y2: Number.MIN_VALUE,
        width: 0,
        height: 0,
    })
}

function getGridMeta(objects) {
    return objects.reduce((acc, object) => {
        if (object.pos.x < acc.x) acc.x = object.pos.x
        if (object.pos.y < acc.y) acc.y = object.pos.y
        if (object.pos.x + object.pos.width > acc.x2) acc.x2 = object.pos.x + object.pos.width
        if (object.pos.y + object.pos.height > acc.y2) acc.y2 = object.pos.y + object.pos.height
        acc.width = acc.x2 - acc.x
        acc.height = acc.y2 - acc.y

        return acc
    }, {
        x: Number.MAX_VALUE,
        y: Number.MAX_VALUE,
        x2: Number.MIN_VALUE,
        y2: Number.MIN_VALUE,
        width: 0,
        height: 0,
    })
}


// WEBPACK FOOTER //
// ./plugins/GridOverlay.js